import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

function ManageProvider() {
  const classes = useStyles();
  return (
    <div className={classes.btncol}>
      <Link to="/manage-provider">
        <Button className={classes.managebtn}>Manage Doctors</Button>
      </Link>
    </div>
  );
}

export default ManageProvider;
const useStyles = makeStyles(() => ({
  btncol: {
    "& a": {
      textDecoration: "none",
    },
  },
  managebtn: {
    width: "180px",
    height: "45px",
    background: "#88b3eb",
    borderRadius: "10px",
    fontSize: "16px",
    color: "#fff",
    textTransform: "capitalize",
    marginBottom: "20px",
    "&:hover": {
      background: "#000",
    },
  },
}));
